/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSupplementalFormAttachment
 */
export interface ControlSupplementalFormAttachment {
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    attachment_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    form_instance_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    file_type: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    updated_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalFormAttachment
     */
    created_at: string;
    /**
     * 
     * @type {number}
     * @memberof ControlSupplementalFormAttachment
     */
    file_size: number;
}

/**
 * Check if a given object implements the ControlSupplementalFormAttachment interface.
 */
export function instanceOfControlSupplementalFormAttachment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "attachment_id" in value;
    isInstance = isInstance && "form_instance_id" in value;
    isInstance = isInstance && "locale" in value;
    isInstance = isInstance && "file_type" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "file_size" in value;

    return isInstance;
}

export function ControlSupplementalFormAttachmentFromJSON(json: any): ControlSupplementalFormAttachment {
    return ControlSupplementalFormAttachmentFromJSONTyped(json, false);
}

export function ControlSupplementalFormAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSupplementalFormAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachment_id': json['attachment_id'],
        'form_instance_id': json['form_instance_id'],
        'locale': json['locale'],
        'file_type': json['file_type'],
        'updated_at': json['updated_at'],
        'created_at': json['created_at'],
        'file_size': json['file_size'],
    };
}

export function ControlSupplementalFormAttachmentToJSON(value?: ControlSupplementalFormAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachment_id': value.attachment_id,
        'form_instance_id': value.form_instance_id,
        'locale': value.locale,
        'file_type': value.file_type,
        'updated_at': value.updated_at,
        'created_at': value.created_at,
        'file_size': value.file_size,
    };
}

